import { Controller } from "@hotwired/stimulus"

/**
 * Sidebar Header Drag Controller
 *
 * Turns the conversation header into a drag handle for the global assistant
 * sidebar. Lives inside the conversation turbo-frame, so it can't reach the
 * global-sidebar controller directly — it talks to it via a custom event.
 *
 * On mousedown / touchstart over the header background (not on a button, link,
 * or other interactive element) it dispatches `global-sidebar:drag-start-request`
 * with the cursor coordinates, and the sidebar controller picks the gesture up.
 *
 *   <div data-controller="sidebar-header-drag"
 *        data-action="mousedown->sidebar-header-drag#start touchstart->sidebar-header-drag#start">
 *     ...buttons...
 *   </div>
 */
export default class extends Controller {
  start(event) {
    if (this._isInteractiveTarget(event.target)) return

    const point = event.touches ? event.touches[0] : event
    if (!point) return

    // Prevent the default mousedown focus-shift / text-selection only when the
    // browser allows it (touchstart listeners are passive by default).
    if (event.cancelable) event.preventDefault()
    document.dispatchEvent(new CustomEvent("global-sidebar:drag-start-request", {
      detail: { clientX: point.clientX, clientY: point.clientY }
    }))
  }

  _isInteractiveTarget(target) {
    if (!target || target === this.element) return false
    return Boolean(target.closest("button, a, input, select, textarea, [role='button']"))
  }
}
